import * as Sentry from "@sentry/nextjs";
import { NextRouter, withRouter } from "next/router";
import React from "react";
import { PagesEnum } from "../../../utils/enums";
import { getPageLink } from "../../../utils/help/navigation/navigation";
import { SadFaceIcon } from "../../global/Icons/Icons";
import styles from "./ErrorBoundary.module.scss";

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  { router: NextRouter; children?: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: any) {
    super(props);

    this.state = { hasError: false };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtra("componentStack", errorInfo.componentStack);
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={`${styles.container} bg__gradient`}>
          <div className={styles.svg_container}>
            <SadFaceIcon />
          </div>
          <div className={styles.title}>Oops!</div>
          <div className={styles.info}>Something went wrong</div>
          <div className={styles.padded_container}>
            <button
              className={styles.btn}
              data-testid={`generic-error-modal-button`}
              onClick={() =>
                window.location.replace(
                  getPageLink(this.props.router, PagesEnum.Home).as
                )
              }
              style={{ fontSize: "1rem" }}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
